import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import DeliveryLogsTable from '../components/DeliveryLogsTable';
import DeliveryLogsSkeleton from '../components/DeliveryLogsSkeleton';
import DeliveryLogsEmptyState from '../components/DeliveryLogsEmptyState';
import LoadMoreButton from '../../../components/LoadMoreButton';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useGetDeliveryLogsHandler } from '../dataHandlers/getDeliveryLogsHandler';
import { PaginationDefaults } from '../../../constants/defaults';

const DeliveryLogsListPage = () => {
  useDocumentTitle('Delivery Logs');
  const { deliveryLogId } = useParams();

  const orgId = '682c5990bf4a775c8de9598a'; // TODO: Replace with dynamic orgId once integrated with Auth Service

  const { deliveryLogs, hasMore, isLoading, isLoadingMore, loadMore } = useGetDeliveryLogsHandler({ orgId });

  // Render loading state
  if (isLoading) {
    return (
      <Box sx={{ py: 1.5, px: 3 }}>
        <DeliveryLogsSkeleton pageLimit={PaginationDefaults.REQUESTS_LIMIT} />
      </Box>
    );
  }

  // Render empty state
  if (!isLoading && deliveryLogs.length === 0) {
    return (
      <Box sx={{ py: 1.5, px: 3 }}>
        <DeliveryLogsEmptyState />
      </Box>
    );
  }

  // Render delivery logs list
  return (
    <Stack sx={{ height: '86vh', display: 'flex', flexDirection: 'row' }}>
      {/* Left Panel: Delivery Logs List */}
      <Box sx={{ flex: 1, minWidth: 0, overflowY: 'auto', p: 2 }}>
        <DeliveryLogsTable deliveryLogs={deliveryLogs} selectedDeliveryLogId={deliveryLogId} />
        {/* Load More */}
        {hasMore && (
          <Box sx={{ px: 3, py: 2 }}>
            <LoadMoreButton onClick={loadMore} isLoading={isLoadingMore} label="Load More Delivery Logs" />
          </Box>
        )}
      </Box>
    </Stack>
  );
};

export default DeliveryLogsListPage;
